import { render, staticRenderFns } from "./Recipient.vue?vue&type=template&id=b74dde8e&scoped=true&"
import script from "./Recipient.vue?vue&type=script&lang=js&"
export * from "./Recipient.vue?vue&type=script&lang=js&"
import style0 from "./Recipient.vue?vue&type=style&index=0&id=b74dde8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74dde8e",
  null
  
)

component.options.__file = "Recipient.vue"
export default component.exports